import React, { useEffect } from "react";
import { TextList, TextListItem } from "../../components/TextList/TextList";
import ContactForm from "../../components/ContactForm/ContactForm";
import Layout from "../../components/Layout/Layout";
import * as S from "./Styles";

const Contact = () => {
  const listOfItems = [
    "Tilbygg og renovering",
    "Bytte av vinduer og dører",
    "Bygging av terrasser og uteområder",
    "Innvendig og utvendig kledning",
    "Takarbeid og takrenovering",
    "Reparasjon og vedlikehold",
    ".. og mye mer!",
  ];

  useEffect(() => {
    if (window.location.hash === "#contact-form") {
      const element = document.querySelector("#contact-form");
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, []);

  return (
    <Layout
      title="Kontakt tømrer og snekker i Vestby | Grønvold Byggservice - Gratis befaring"
      description="Kontakt Grønvold Byggservice i dag for tømrer- og snekkertjenester i Vestby. Vi tilbyr gratis befaring og skreddersydde løsninger tilpasset dine behov.">
      <S.Container>
        <S.ContactInformation>
          <h1>Kontakt Grønvold Byggservice</h1>
          <p>
            Send oss en henvendelse med informasjon om arbeid du ønsker utført. Vi utfører det meste innen tømrer- og
            snekkerarbeid, rehabilitering og serviceoppdrag.
          </p>
          <TextList>
            {listOfItems.map((item, index) => (
              <TextListItem key={index}>{item}</TextListItem>
            ))}
          </TextList>
        </S.ContactInformation>
        <ContactForm />
      </S.Container>
    </Layout>
  );
};

export default Contact;
